import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';
import Switch from 'react-toggle-switch';
import Loading from '../../../components/Loading';
import api from '../../../services/api';
import { Container, Table, ButtonPanel } from './styles';
import 'react-toggle-switch/dist/css/switch.min.css';

import Button from '../../../components/Button';

export default class EventPromoters extends Component {
  state = {
    alert: {},
    compact: false,
    currentEvent: null,
    loading: true,
    promoters: [],
    showAlert: false,
  };

  genreTranslation = {
    male: 'Masculino',
    female: 'Feminino',
  };

  static propTypes = {
    match: PropTypes.shape().isRequired,
  };

  componentDidMount() {
    this.loadEvent();
    this.loadEventPromoters();
  }

  loadEvent = async () => {
    try {
      const { data } = await api.get(`admin/events/${this.props.match.params.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });

      this.setState({ currentEvent: data.event });
    } catch (err) {
      this.setState({ loading: false });
      const messages = err.response && err.response.data && err.response.data.errors
        ? err.response.data.errors
        : ['Não foi possível carregar o evento. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  loadEventPromoters = async () => {
    try {
      const { data } = await api.get('admin/event_promoters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
        params: {
          event_id: this.props.match.params.id,
        },
      });

      data.promoters = data.promoters.map(promoter => ({
        ...promoter,
        genre: this.genreTranslation[promoter.genre],
      }));
      this.setState({ promoters: data.promoters, loading: false });
    } catch (err) {
      this.setState({ loading: false });
      const messages = err.response && err.response.data && err.response.data.errors
        ? err.response.data.errors
        : ['Não foi possível carregar os divulgadores. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  toggleSwitch = () => {
    this.setState(prevState => ({
      compact: !prevState.compact,
    }));
  };

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      compact,
      currentEvent,
      loading,
      promoters,
      showAlert,
    } = this.state;

    return (
      <Fragment>
        {loading ? (
          <Loading />
        ) : (
          <Container>
            <h1 className="page-title">
              Relatório de participação - {currentEvent && currentEvent.name}
            </h1>
            <div className="box">
              <div className="row">
                <div className="col-12">
                  {promoters.length > 0 ? (
                    <Fragment>
                      <ButtonPanel className="no-print">
                        <Button
                          type="button"
                          className="btn btn-success"
                          onClick={() => window.print()}
                        >
                          Imprimir
                        </Button>

                        <div className="compact-version">
                          <span>Versão compacta</span>
                          <Switch onClick={this.toggleSwitch} on={compact} />
                        </div>
                      </ButtonPanel>
                      {compact ? (
                        <div className="table-wrapper">
                          <Table className="table">
                            <thead>
                              <tr>
                                <th>Foto</th>
                                <th>Nome</th>
                                <th>Celular</th>
                                <th>RG</th>
                              </tr>
                            </thead>
                            <tbody>
                              {promoters
                                .filter(promoter => promoter.participation_status === 'active')
                                .map(promoter => (
                                  <tr key={promoter.id}>
                                    <td>
                                      <div
                                        className="profile-image"
                                        style={
                                          promoter.avatar.url && {
                                            backgroundImage: `url(${promoter.avatar.url})`,
                                          }
                                        }
                                      />
                                    </td>
                                    <td>{promoter.name}</td>
                                    <td>{promoter.phone}</td>
                                    <td>{promoter.rg}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </Table>
                        </div>
                      ) : (
                        <div className="table-wrapper">
                          <Table className="table">
                            <thead>
                              <tr>
                                <th>Nome</th>
                                <th>Cidade</th>
                                <th>Instagram</th>
                                <th>RG</th>
                                <th>Nº de advertências</th>
                                <th>Status no evento</th>
                              </tr>
                            </thead>
                            <tbody>
                              {promoters.map(promoter => (
                                <tr key={promoter.id}>
                                  <td>{promoter.name}</td>
                                  <td>{promoter.city}</td>
                                  <td>
                                    <a
                                      href={`http://instagram.com/${promoter.instagram_username}`}
                                      target="blank"
                                    >
                                      @{promoter.instagram_username}
                                    </a>
                                  </td>
                                  <td>{promoter.rg}</td>
                                  <td>{promoter.advertence_count}</td>
                                  <td>{promoter.participation_status_i18n}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </Fragment>
                  ) : (
                    <h5 className="text-center">Este evento não possui divulgadores.</h5>
                  )}
                </div>
              </div>
            </div>

            {showAlert && (
              <SweetAlert
                type={type}
                confirmBtnText={confirmBtnText}
                confirmBtnBsStyle={confirmBtnBsStyle}
                showCancel={showCancel}
                cancelBtnText={cancelBtnText}
                cancelBtnBsStyle={cancelBtnBsStyle}
                title={title}
                onConfirm={onConfirm}
                onCancel={this.closeAlert}
              >
                <ul>
                  {messages.map(msg => (
                    <li key={msg}>{msg}</li>
                  ))}
                </ul>
              </SweetAlert>
            )}
          </Container>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/pages/EventReport/index.js